import React, { Component } from 'react';
import {
  BrowserRouter,
  Route,
  Switch,
} from 'react-router-dom';

import HomePage from './HomePage';
import ContactPage from './ContactPage';
import PositionPage from './PositionPage';
import NavBar from './NavBar';


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: window.innerWidth,
    };
    this.resize = this.resize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize() {
    this.setState({
      windowWidth: window.innerWidth,
    });
  }

  render() {
    const pageProps = {
      windowWidth: this.state.windowWidth,
    };

    return (
      <BrowserRouter basename="/tmd_recruit">
        <div className="app">
          <NavBar windowWidth={this.state.windowWidth} />

          <Switch>
            <Route
              exact
              path="/"
              render={
                ({location}) => {
                  return (<HomePage locHash={location.hash} {...pageProps} />);
                }}
            />
            <Route exact path="/contact" render={() => <ContactPage {...pageProps} />} />
            <Route
              exact
              path="/:section/:position"
              render={
                ({ match }) => (
                  <PositionPage
                    section={match.params.section}
                    position={match.params.position}
                    {...pageProps}
                  />
                )}
            />
            <Route
              exact
              path="/:section"
              render={
                ({ match }) => (
                  <PositionPage
                    section={match.params.section}
                    {...pageProps}
                  />
                )}
            />
          </Switch>

          <div className="footer" />
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx